import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import ProposalDocument from '../components/proposal/ProposalDocument';
import ProposalToolbar from '../components/proposal/ProposalToolbar';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ProposalPreview() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [proposal, setProposal] = useState(null);
  const [loading, setLoading] = useState(true);
  const printRef = useRef();

  useEffect(() => {
    const fetchProposal = async () => {
      try {
        const response = await axios.get(`${API}/proposals/${id}`);
        setProposal(response.data);
      } catch (error) {
        console.error('Failed to fetch proposal:', error);
        toast.error('Failed to load proposal');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchProposal();
    }
  }, [id]);

  const handlePrint = () => {
    window.print();
  };

  const handleBack = () => {
    navigate('/proposals');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="flex items-center gap-3 text-slate-600">
          <Loader2 className="w-6 h-6 animate-spin" />
          <span>Loading proposal...</span>
        </div>
      </div>
    );
  }

  if (!proposal) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="text-center">
          <p className="text-slate-600 mb-4">Proposal not found</p>
          <button 
            onClick={handleBack}
            className="text-orange-600 hover:text-orange-700 font-medium"
          >
            Back to Proposals
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100 print:bg-white">
      <ProposalToolbar 
        onPrint={handlePrint}
        onBack={handleBack}
      />
      <div className="py-10 px-4 flex justify-center print:p-0 print:block" id="print-wrapper">
        <ProposalDocument 
          proposal={proposal} 
          printRef={printRef} 
        />
      </div>
    </div>
  );
}
